/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Voice_GlitchInputs */



/**
* | output |
* | --- |
* | "We could not play the voice just then. Keep talking, or finish up to see your feedback." |
*
* @param {Practice_Session_Voice_GlitchInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_voice_glitch = /** @type {((inputs?: Practice_Session_Voice_GlitchInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Voice_GlitchInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("We kregen de stem even niet afgespeeld. Praat gerust verder, of rond af om je feedback te bekijken.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous n'avons pas pu jouer la voix à l'instant. Continuez à parler, ou terminez pour voir votre feedback.")
	return /** @type {LocalizedString} */ ("We could not play the voice just then. Keep talking, or finish up to see your feedback.")
});